import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { CustomHTML } from "./CustomHTML";
import { defaultData } from "./customHTMLBlockDefaultData";

export const CustomHTMLBlock: BlockExport = {
  type: "component",
  Block: CustomHTML,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-media-custom-html",
    size: 24,
  },
  defaultData,
  meta: {
    name: "Custom HTML",
    version: 1,
    nameI18n: "builder_ui.block_type.custom_html",
    category: [BasicBlock],
    props: {
      content: {
        name: "Code",
        nameI18n: "builder_ui.prop_type.code",
        prop: "other",
        type: "custom-html",
        defaultValue: {
          head: `<!-- Add <head> content here like:
      - <link> tags for external CSS
      - <style> tags for custom CSS
      - <script> tags for JavaScript -->`,
          body: `<!-- Add <body> content here like:
      - HTML elements (<div>, <p>, etc.)
      - Embedded content and widgets -->`,
        },
      },
    },
  },
};
